(function(){
  var TREE=[
    {sec:'Shop by Festival', rows:[
      {title:'Raksha Bandhan', h:'rakhi', chips:[['For Brother','rakhi-for-brother'],['Bhaiya Bhabhi','rakhi-for-sister'],['Kids','rakhi-kids']]},
      {title:'Janmashtami', h:'janmashtami', sublabel:'Laddu Gopal dresses by size', chips:[['All Dresses','janmashtami'],['Size 0','janmashtami-dresses-size-0'],['Size 1','janmashtami-dresses-size-1'],['Size 2','janmashtami-dresses-size-2'],['Size 3','janmashtami-dresses-size-3'],['Size 4','janmashtami-dresses-size-4'],['Size 6','janmashtami-dresses-size-6']]},
      {title:'Diwali & Festive Décor', h:'', chips:[['Toran','toran'],['Tea Lights','tea-light'],['Hangings','hanging']]},
      {title:'Wedding & Groom', h:'wedding-groom', chips:[]}
    ]},
    {sec:'Shop by Category', rows:[
      {title:'Mandir & Pooja', h:'', chips:[['Mandir','mandir'],['Singhasan','singhasan'],['Pooja Thali','pooja-thali'],['Mala','mala'],['Roli Chawal Platter','roli-chawal-platter'],['Shubh Labh','shubh-labh']]},
      {title:'Gifting', h:'gift-hampers', chips:[['Gift Hampers','gift-hampers']]}
    ]}
  ];
  var CSS=
  '.tyo-cols{max-width:1080px;margin:0 auto;padding:10px 16px 56px;font-family:"DM Sans",-apple-system,sans-serif}'+
  '.tyo-cols *{box-sizing:border-box}'+
  '.tyo-cols-head{text-align:center;margin:6px 0 26px}'+
  '.tyo-cols-eyebrow{font-size:11px;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;color:#C51985}'+
  '.tyo-cols-title{font-family:Georgia,serif;font-size:30px;font-weight:700;color:#292323;margin:4px 0 0}'+
  '.tyo-cols-sec{margin-bottom:30px}'+
  '.tyo-cols-sech{font-family:Georgia,serif;font-size:19px;font-weight:700;color:#292323;margin:0 0 12px;padding-bottom:8px;border-bottom:2px solid #F0E4D2}'+
  '.tyo-cols-row{background:#fff;border:1px solid #EFE4D2;border-radius:12px;padding:14px 16px;margin-bottom:11px;transition:box-shadow .18s,border-color .18s}'+
  '.tyo-cols-row:hover{box-shadow:0 8px 22px rgba(197,25,133,.08);border-color:rgba(197,25,133,.3)}'+
  '.tyo-cols-top{display:flex;align-items:center;justify-content:space-between;gap:12px}'+
  '.tyo-cols-name{font-family:Georgia,serif;font-size:16px;font-weight:700;color:#292323;text-decoration:none}'+
  '.tyo-cols-name:hover{color:#C51985}'+
  '.tyo-cols-go{font-size:11px;font-weight:700;letter-spacing:1px;color:#C51985;text-decoration:none;white-space:nowrap}'+
  '.tyo-cols-sublabel{font-size:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#a2937f;margin:12px 0 6px}'+
  '.tyo-cols-chips{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}'+
  '.tyo-cols-chip{font-size:12.5px;color:#5a4f45;background:#FBF4E9;border:1px solid #EFE4D2;border-radius:999px;padding:6px 13px;text-decoration:none;white-space:nowrap;transition:.15s}'+
  '.tyo-cols-chip:hover{background:#C51985;color:#fff;border-color:#C51985}'+
  '@media(max-width:600px){.tyo-cols-title{font-size:24px}.tyo-cols-name{font-size:15px}}';
  function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;');}
  function rowHTML(r){
    var html='<div class="tyo-cols-row"><div class="tyo-cols-top">';
    if(r.h){ html+='<a class="tyo-cols-name" href="/collections/'+r.h+'">'+esc(r.title)+'</a><a class="tyo-cols-go" href="/collections/'+r.h+'">VIEW ALL &rarr;</a>'; }
    else { html+='<span class="tyo-cols-name">'+esc(r.title)+'</span>'; }
    html+='</div>';
    if(r.chips && r.chips.length){
      if(r.sublabel) html+='<div class="tyo-cols-sublabel">'+esc(r.sublabel)+'</div>';
      html+='<div class="tyo-cols-chips">';
      r.chips.forEach(function(c){ html+='<a class="tyo-cols-chip" href="/collections/'+c[1]+'">'+esc(c[0])+'</a>'; });
      html+='</div>';
    }
    html+='</div>';
    return html;
  }
  function run(){
    if(location.pathname!=='/collections' && !/^\/collections\/?$/.test(location.pathname)) return;
    if(document.getElementById('tyo-cols')) return;
    var main=document.getElementById('MainContent')||document.querySelector('main'); if(!main) return;
    main.querySelectorAll('[id^="shopify-section-"]').forEach(function(s){
      if(s.querySelector('a[href*="/collections/"]')) s.style.display='none';
    });
    var st=document.createElement('style'); st.textContent=CSS; document.head.appendChild(st);
    var wrap=document.createElement('div'); wrap.id='tyo-cols'; wrap.className='tyo-cols';
    var html='<div class="tyo-cols-head"><div class="tyo-cols-eyebrow">Explore Tyohaare</div><h1 class="tyo-cols-title">Collections</h1></div>';
    TREE.forEach(function(g){
      html+='<div class="tyo-cols-sec"><div class="tyo-cols-sech">'+esc(g.sec)+'</div>';
      g.rows.forEach(function(r){ html+=rowHTML(r); });
      html+='</div>';
    });
    wrap.innerHTML=html;
    main.insertBefore(wrap, main.firstChild);
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();